import { useRouter, useSearchParams } from "next/navigation";
import { useEffect, useState } from "react";
import AddIcon from "../AddIcon";
import ArticleCard from "../ArticleCard";
import styles from "./ThankYou.module.css";
export default function ThankYou() {
  const searchParams = useSearchParams();
  const router = useRouter();
  const paramName = "thanks";
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setIsOpen(searchParams.has(paramName));
  }, [searchParams]);

  const handleClose = () => {
    const params = new URLSearchParams(window.location.search);
    params.delete(paramName);
    router.replace(
      `${window.location.pathname}${params.toString() ? `?${params}` : ""}`,
      { scroll: false },
    );
    setIsOpen(false);
  };

  if (!isOpen) return null;

  return (
    <aside
      className={`${styles.thankYou} ${isOpen && styles.open}`}
      data-theme="secondary"
    >
      <div className={styles.closeButton} onClick={handleClose}>
        <AddIcon />
      </div>
      <div className="grid-container">
        <header className={`${styles.header} sm-col-span-8 lg-col-span-4`}>
          <h2>Thank You</h2>
        </header>
        <div className="sm-col-span-hide lg-col-span-1" />
        <p className={`${styles.text} sm-col-span-8 lg-col-span-5`}>
          We will contact you as soon as possible.In the meantime, feel free to
          explore our Discover universe.
        </p>
        <div className="sm-col-span-hide lg-col-span-5" />
        <div className={`${styles.content} sm-col-span-8 lg-col-span-4`}>
          <ArticleCard
            title="Discover the Universe"
            content="Explore our latest articles and insights."
            image="building-company-culture-in-a-hybrid-world-why-physical-space-still-matters.jpg"
            slug="/discover"
            tags={["Discover", "Universe", "Articles"]}
          />
        </div>
      </div>
    </aside>
  );
}
